import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { CALENDAR_VIEWS, flownectColors } from "../../const";
import { colors, alphaVar } from "../../../../ui/colors";
import { Restore } from "@mui/icons-material";

export const NavigationControls = ({ onToday, viewType }) => {
  const labels = {
    [CALENDAR_VIEWS.DAY]: { prev: "Previous Day", next: "Next Day", today: "Today" },
    [CALENDAR_VIEWS.MONTH]: { prev: "Previous Month", next: "Next Month", today: "This Month" },
    [CALENDAR_VIEWS.LIST]: { prev: "Previous Week", next: "Next Week", today: "This Week" },

    timeGridDay: { prev: "Previous Day", next: "Next Day", today: "Today" },
    dayGridMonth: { prev: "Previous Month", next: "Next Month", today: "This Month" },
    listWeek: { prev: "Previous Week", next: "Next Week", today: "This Week" },
  };

  const currentLabels = labels[viewType] || labels[CALENDAR_VIEWS.DAY];

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Button
        size="small"
        onClick={onToday}
        startIcon={<Restore sx={{ fontSize: "16px" }} />}
        sx={{
          width: 170,
          px: 2,
          height: "32px",
          background: colors.orange.base,
          color: "white",
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.8rem",
          borderRadius: "8px",
          border: `1px solid ${alphaVar(colors.orange.base, 0.4)}`,
          transition: "all 0.2s",
          "&:hover": {
            background: colors.orange[600],
            color: "white",
          },
        }}
      >
        Go to {currentLabels.today}
      </Button>
    </Box>
  );
};
